import { useUpdateAlarmFromModel } from '@akin-home/alarms/react';
import { useUpdateAlertFromModel } from '@akin-home/alerts/frontend';
import { useUpdateEventFromModel } from '@akin-home/events/react';
import { useUpdateMealFromModel } from '@akin-home/meals/react';
import { useCallback } from 'react';
import { CalendarItemUnion } from '../types';

export const useUpdateCalendarItem = () => {
  const updateEvent = useUpdateEventFromModel();
  const updateAlarm = useUpdateAlarmFromModel();
  const updateAlert = useUpdateAlertFromModel();
  const updateMeal = useUpdateMealFromModel();

  return useCallback(
    async (item: CalendarItemUnion) => {
      switch (item.type) {
        case 'Event':
          return updateEvent(item);
        case 'Alarm':
          return updateAlarm(item);
        case 'Alert':
          return updateAlert(item);
        case 'Meal':
          return updateMeal(item);
        default:
          return undefined;
      }
    },
    [updateAlert, updateEvent, updateAlarm, updateMeal]
  );
};
